import { HotelAuxList } from '../../../../api/models/hotelAuxList.model'
import { RoomAuxList } from '../../../../api/models/roomAuxList.model'
import { RoomTypeAuxList } from '../../../../api/models/roomTypeAuxList.model'
import { createDeepEqualSelector } from '../../../store'
import { State } from '../../../store.types'
import { selectApiUserEnvironmentDataAuxList } from '../ApiUsersSlice/ApiUsersSlice.selectors'

interface RoomTypeAuxListWithRooms extends RoomTypeAuxList {
  rooms: RoomAuxList[]
}

export interface HotelAuxListWithRoomTypes extends HotelAuxList {
  roomTypes: RoomTypeAuxListWithRooms[]
}

export const selectApiUserDetailsStates = (state: State) =>
  state.apiUserDetails.ApiUserDetailsStates

export const selectApiUserDetailsByWindowId = (windowId: string) =>
  createDeepEqualSelector([selectApiUserDetailsStates], (apiUserDetailsState) =>
    apiUserDetailsState.find(
      (apiUserDetails) => apiUserDetails.windowId === windowId
    )
  )

export const selectUserAuxByWindowId = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (userDetails) => userDetails?.data?.userAux
  )

export const selectApiUserDetailsLoading = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetailsState) => apiUserDetailsState?.loading
  )

export const selectApiUserDetailsError = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetailsState) => apiUserDetailsState?.error
  )

export const selectApiUserRoles = (windowId: string) =>
  createDeepEqualSelector(
    [
      selectApiUserDetailsByWindowId(windowId),
      selectApiUserEnvironmentDataAuxList(windowId)
    ],
    (apiUserDetails, environmentDataAuxList) => {
      const userEnvironmentDataAuxList =
        apiUserDetails?.data?.userEnvironmentDataAuxList
      if (userEnvironmentDataAuxList != null) {
        return userEnvironmentDataAuxList.map((userEnvironmentDataAux) => {
          const environmentDataAux = environmentDataAuxList?.find(
            (environmentDataAux) =>
              environmentDataAux.id === userEnvironmentDataAux.environmentDataId
          )
          return {
            ...userEnvironmentDataAux, environmentDataAux
          }
        })
      }
    }
  )

export const selectUserDetailsRolesAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userRoleAuxList
  )

export const selectUserDetailsUserEnvironmentDataAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userEnvironmentDataAuxList
  )

export const selectUserDetailsUserZoneAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userZoneAuxList
  )
export const selectUserDetailsUserHotelAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userHotelAuxList
  )
export const selectUserDetailsUserRoomTypeAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userRoomTypeAuxList
  )

export const selectUserDetailsUserRoomAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userRoomAuxList
  )

export const selectUserDetailsUserChannelAuxList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userChannelAuxList
  )

export const selectUserDetailsUserBillingEntityList = (windowId: string) =>
  createDeepEqualSelector(
    [selectApiUserDetailsByWindowId(windowId)],
    (apiUserDetails) => apiUserDetails?.data?.userBillingEntityList
  )

// export const
